import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Sidebar = () => {
  const { user } = useAuth();
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  if (!user) return null;

  const links = {
    passenger: [
      { to: '/passenger/topup', label: 'Top Up Wallet' },
      { to: '/passenger/trips', label: 'Available Trips' },
      { to: '/passenger/history', label: 'My Transactions' }
    ],
    mashell: [
      { to: '/mashell/queue', label: 'Today Queue' }
    ],
    owner: [
      { to: '/owner/vehicles', label: 'My Vehicles' },
      { to: '/owner/add-vehicle', label: 'Add Vehicle' },
      { to: '/owner/transactions', label: 'Transactions' }
    ]
  };

  const currentLinks = links[user.role] || [];

  const handleLinkClick = () => {
    setIsMobileOpen(false); // close mobile menu on link click
  };

  return (
    <>
      {/* Hamburger for mobile */}
      <button 
        className="mobile-menu-toggle"
        onClick={() => setIsMobileOpen(!isMobileOpen)}
        aria-label="Toggle menu"
      >
        <span></span><span></span><span></span>
      </button>

      {/* Sidebar (always rendered, controlled by class) */}
      <aside className={`sidebar glass-card ${isMobileOpen ? 'open' : ''}`}>
        <nav className="sidebar-nav">
          {currentLinks.map(link => (
            <NavLink
              key={link.to}
              to={link.to}
              onClick={handleLinkClick}
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* Overlay for mobile */}
      {isMobileOpen && <div className="sidebar-overlay" onClick={() => setIsMobileOpen(false)} />}

      <style>{`
        .sidebar {
          width: 260px;
          min-height: calc(100vh - 73px);
          padding: 1.5rem;
          margin: 1rem;
          border-radius: var(--radius-lg);
          transition: transform 0.3s ease;
        }

        .sidebar-nav {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .sidebar-link {
          padding: 0.75rem 1rem;
          border-radius: var(--radius-sm);
          text-decoration: none;
          color: var(--text);
          font-weight: 500;
          transition: var(--transition);
        }

        .sidebar-link:hover {
          background: var(--primary-light);
          color: var(--primary);
        }

        .sidebar-link.active {
          background: var(--primary);
          color: white;
        }

        /* Mobile toggle button */
        .mobile-menu-toggle {
          display: none;
          position: fixed;
          top: 1rem;
          left: 1rem;
          z-index: 150;
          background: var(--primary);
          border: none;
          border-radius: var(--radius-sm);
          padding: 0.5rem;
          cursor: pointer;
          flex-direction: column;
          gap: 4px;
          width: 40px;
          height: 40px;
          align-items: center;
          justify-content: center;
        }

        .mobile-menu-toggle span {
          display: block;
          width: 24px;
          height: 2px;
          background: white;
          border-radius: 2px;
        }

        /* Sidebar overlay (mobile) */
        .sidebar-overlay {
          display: none;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
          z-index: 120;
        }

        @media (max-width: 768px) {
          .sidebar {
            position: fixed;
            top: 0;
            left: 0;
            height: 100vh;
            z-index: 130;
            transform: translateX(-100%);
            margin: 0;
            border-radius: 0 var(--radius-lg) var(--radius-lg) 0;
          }

          .sidebar.open {
            transform: translateX(0);
          }

          .mobile-menu-toggle {
            display: flex;
          }

          .sidebar-overlay {
            display: block;
          }
        }
      `}</style>
    </>
  );
};

export default Sidebar;